<template>
  <div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      @click="createCertificate">新建证书</el-button>
    <certificate-modal
      ref="modal"
      :vendorId="userInfo.orgId"
      :fetch="fetchList" />
  </div>
</template>

<script>
import CertificateModal from '../certificate-modal.vue'
import { mapState } from 'vuex'
export default {
  name: 'CreateCertificateBtn',
  components: { CertificateModal },
  props: {
    fetch: Function
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  watch: {},
  created() { },
  mounted() { },
  methods: {
    createCertificate() {
      this.$refs.modal.toggleModal(true)
    },
    fetchList() {
      this.fetch && this.fetch()
    }
  }
}
</script>
<style lang="stylus" scoped></style>
